import { createAsyncThunk } from '@reduxjs/toolkit';

import { userApi } from '~/api/account/userApi';
import { GetUserSubscribersParams } from '~/api/account/userApiTypes';
import {
  authorSubscribersActions,
  authorSubscribersSliceName,
} from '~/atomic/page/author/subscribers/authorSubscribers.slice';
import { paginationActions } from '~/feature/pagination/pagination.slice';
import { environments } from '~/lib/const';
import { RootState } from '~/store';

export const getAuthorSubscribers = createAsyncThunk<
void,
GetUserSubscribersParams,
{ rejectValue: { error: string }; state: RootState }
>(
  `${authorSubscribersSliceName}/getAuthorSubscribers`,
  async (
    data,
    thunkAPI,
  ) => {
    try {
      const { page, perPage } = thunkAPI.getState().pagination;
      const result = await userApi.getUserSubscribers({
        username: data.username,
        page: data.page ?? page,
        perPage: data.perPage ?? perPage,
      });
      if (result && 'data' in result) {
        thunkAPI.dispatch(authorSubscribersActions.changeSubscribers(result.data));
        thunkAPI.dispatch(paginationActions.initPagination({
          total: result.total,
          page: result.currentPage,
          perPage: result.perPage,
        }));
      }
    } catch (error) {
      if (environments.isClient && error instanceof Error) {
        const { message } = await import('~/atomic/atom/message');
        message.error(error.message);
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  },
);
